
const FISH_LABEL = `Supplement Facts
Serving Size: 1 Softgel
Servings Per Container: 100
                                   Amount Per Serving   % Daily Value**
Calories                           10
Total Fat                          1g                   1%*
Polyunsaturated Fat                0.5g                 **
Cholesterol                        10mg                 3%*
Fish oil concentrate               1,000mg              **
Eicosapentaenoic acid (EPA)        180mg                **
Docosahexaenoic acid (DHA)         120mg                **
*Percent Daily Values are based on a 2,000 calorie diet
**Daily Value not established.
Other Ingredients: Softgel (gelatin, glycerin and water) and Vitamin E.
Contains: Fish (Sardines, Anchovies)
Suggested use: Take 1 softgel twice daily with meals. 360 mg EPA + 240 mg DHA per day (2 softgels). 100 softgels = 50-day supply.`;

const SEAMOSS_LABEL = `Supplement Facts
Serving Size: 2 Capsules
Servings Per Container: 30
                                                         Amount Per Serving   % DV
Organic Irish Moss (Chondrus crispus)(whole plant)       500 mg               **
Organic Bladderwrack (Fucus vesiculosus)(whole plant)    500 mg               **
Organic Burdock (Arctium lappa)(root)                    400 mg               **
BioPerine(R) (Black Pepper Extract) (Piper nigrum)(fruit)  5 mg               **
** Daily Value (DV) not established
Other Ingredients: Pullulan Capsules.
Suggested use: 2 capsules once daily (30 servings, 60 capsules).`;

const MULTI_LABEL_TXT = `Serving Size: 2 Capsules   Servings Per Container: 30
Amount Per Serving / %DV
Vitamin A (as Beta-Carotene) 600 mcg RAE 67%
Vitamin C (as Ascorbic Acid) 150 mg 167%
Vitamin D (as Cholecalciferol) 10 mcg 50%
Vitamin E (as DL-Alpha Tocopherol Acetate) 13.5 mg 90%
Vitamin B1 (as Thiamine Mononitrate) 7 mg 583%
Vitamin B2 (as Riboflavin) 7.5 mg 577%
Niacin (as Niacin) 30 mg NE 188%
Vitamin B6 (as Pyridoxine HCl) 7.5 mg 441%
Folate 680 mcg DFE (400 mcg Folic Acid) 170%
Vitamin B12 (as Cyanocobalamin) 27 mcg 1125%
Biotin 300 mcg 1000%
Pantothetic Acid [sic] (as D-Calcium Pantothenate) 10 mg 200%
Calcium (as Calcium Carbonate) 50 mg 4%
Magnesium (as Magnesium Oxide) 50 mg 12%
Zinc (as Zinc Oxide) 15 mg 136%
Selenium (as Selenium Amino Acid Chelate) 30 mcg 55%
Copper (as Copper Gluconate) 2 mg 222%
Manganese (as Manganese Amino Acid Chelate) 2 mg 87%
Chromium (as Chromium Picolinate) 120 mcg 343%
Molybdenum 75 mcg 167%
Health Support 170 mg **
  Lutein (Tagetes erecta L.)(flower), Lycopene (Lycopersicum esculentum)(fruit), Stinging Nettle Extract (Urtica dioica)(root), Saw Palmetto (Serenoa repens)(fruit)
Immune Support 110 mg **
  Echinacea Purpurea Powder (Echinacea purpurea)(aerial), Beta Glucan (Saccharomyces cerevisiae), Spirulina Powder (Arthrospira platensis)(whole plant), Garlic (Allium sativum)(bulb)
Antioxidant Fruit & Energy Blend 190 mg **
  Green Tea Extract (Camellia sinensis)(leaf), Chinese Hawthorn Powder (Crataegus pinnatifida)(fruit), Cassia Cinnamon (Cinnamomum cassia)(bark), Bilberry Extract (Vaccinium myrtillus)(fruit), Grape Extract (Vitis vinifera L.)(seed), Black Currant Extract (Ribes nigrum)(fruit), Pomegranate Extract (Punica granatum)(fruit)
**Daily Value (DV) Not Established
Other Ingredients: Rice Flour, Hypromellose (vegetable capsule), Magnesium stearate, Silicon dioxide.`;

const L_FISH = { name: "Omega-3 Fish Oil from sardines & anchovies (EPA 180 mg + DHA 120 mg)", text: FISH_LABEL };
const L_SEAMOSS = { name: "Sea Moss (60 caps)", text: SEAMOSS_LABEL };
const L_MULTI = { name: "Daily Multivitamin (60 caps)", text: MULTI_LABEL_TXT };

const C_EPA = "EPA and DHA are omega-3 fatty acids that support overall health as part of a balanced diet.*";
const C_DHA = "Omega-3 DHA supports brain health.*";
const C_SEA = "Sea moss and bladderwrack are traditional sea vegetables, in an easy capsule.";
const C_VIT = "Vitamins and minerals help fill everyday nutritional gaps.*";
const C_B = "B vitamins support normal energy metabolism.*";

const W_BASE = "Adults only. Do not exceed the recommended dose. Pregnant or nursing women, anyone under 18, and anyone with a medical condition or taking medication should consult a physician before use. Keep out of reach of children. Do not use if safety seal is damaged or missing. Store in a cool, dry place. Contains fish (sardines, anchovies). Consult your doctor before use if you take blood-thinning medication.";
const W_SEA = "Our caution (not on the supplier label): bladderwrack is a natural source of iodine in variable amounts. Consult your doctor before use if you have a thyroid condition, are pregnant or nursing, or take medication. Do not exceed 2 capsules daily.";
const W_MULTI = "Contains green tea extract, echinacea and garlic; consult your doctor if you take medication.";




const FDA_TXT = "*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.";
const WHY_FISH = "People take fish oil to add the omega-3s EPA and DHA to their routine. EPA and DHA support overall health as part of a balanced diet.* Omega-3 DHA supports brain health.*";
const WHY_SEA = "People take sea moss as a traditional sea vegetable to add to their daily routine.";
const WHY_MULTI = "People take a multivitamin to help fill everyday nutrient gaps. Vitamins and minerals support normal energy metabolism and overall wellbeing.*";

export const OCEAN_STORY = "Grandpa Finn kept his routine as steady as the tide: a fish-oil habit he picked up as a kid, a few simple basics, and an early start by the water. The Ocean range bundles that routine into one order, so you don't have to think about it. Grandpa knew.";
export const MEET_FINN = "Grandpa Finn is our mascot: a white-bearded, 70-something surfer in sunglasses and a Hawaiian shirt who has been surfing since '67 and still paddles out at dawn. His rule is simple: look after the basics, every single day, and let the tide do the rest. Grandpa Finn's is our tribute to that steady, no-nonsense routine: honest labels, plain-English science, and no miracle promises. (Grandpa Finn is a fictional character.)";
export const OCEAN_SHIP_NOTE = "Ships to the US, Canada, Europe, Australia & NZ. International: duties paid by customer.";

export const OCEAN = {
  "ocean-daily": {
    sku: "GF-STACK-OCEAN-DAILY", usd: [28.95, 23.16, 32.90], subtitle: "Fish Oil + Sea Moss",
    claims: [C_EPA, C_DHA, C_SEA], labels: [L_FISH, L_SEAMOSS], warnings: [W_BASE, W_SEA],
    why: `${WHY_FISH} ${WHY_SEA} ${FDA_TXT}`,
  },
  "ocean-basics": {
    sku: "GF-STACK-OCEAN-BASICS", usd: [30.95, 24.76, 33.90], subtitle: "Fish Oil + Multivitamin",
    claims: [C_EPA, C_DHA, C_VIT, C_B], labels: [L_FISH, L_MULTI], warnings: [W_BASE, W_MULTI],
    why: `${WHY_FISH} ${WHY_MULTI} ${FDA_TXT}`,
  },
  "full-ocean-stack": {
    sku: "GF-STACK-FULL-OCEAN", usd: [42.95, 34.36, 48.85], subtitle: "Fish Oil + Sea Moss + Multivitamin",
    claims: [C_EPA, C_DHA, C_SEA, C_VIT, C_B], labels: [L_FISH, L_SEAMOSS, L_MULTI], warnings: [W_BASE, `${W_SEA} ${W_MULTI}`],
    why: `${WHY_FISH} ${WHY_SEA} ${WHY_MULTI} ${FDA_TXT}`,
  },
};
export { L_FISH, L_SEAMOSS, L_MULTI, C_EPA, C_DHA, C_SEA, C_VIT, C_B, W_BASE, W_SEA, W_MULTI, FDA_TXT, WHY_FISH, WHY_SEA, WHY_MULTI };
